<template>
    <div class="row">
        <div class="col-12">
            <div class="card" data-toggle="lists">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <!-- Search -->
                            <div class="row align-items-center">
                                <div class="col-auto pr-0">
                                    <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                    <span class="fe fe-search text-muted" v-else></span>
                                </div>
                                <div class="col">
                                    <input
                                        type="search"
                                        v-model="query"
                                        class="form-control form-control-flush search no-glow"
                                        :placeholder="$t('Search')"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="col-auto">
                            <date-filter v-model="dates"></date-filter>
                        </div>
                        <div class="col-auto">
                            <div class="dropdown">
                                <b-button-group>
                                    <button class="btn btn-white" @click="staffQuery=[]" v-if="staffQuery.length>0">
                                        <span class="fe fe-x"></span>
                                    </button>
                                    <b-dropdown variant="white" right :text="$t('Staff')">
                                        <div v-for="(member, index ) in staff" :key="index" class="dropdown-item">
                                            <b-form-checkbox v-model="staffQuery" :value="member._id">
                                                <avatar
                                                    type="circle"
                                                    v-if="member && member.avatar"
                                                    :src="member.avatar.preview"
                                                    size="avatar-xs"
                                                ></avatar>
                                                {{ member.firstName }}
                                            </b-form-checkbox>
                                        </div>
                                    </b-dropdown>
                                </b-button-group>
                            </div>
                        </div>

                        <div class="col-auto">
                            <button
                                @click="openModal({id:'XrayModal', model:xrayDefaults})"
                                class="btn btn-info"
                            >{{ $t('New xray') }}
                            </button>
                        </div>
                    </div>
                    <!-- / .row -->
                </div>

                <simple-table
                    :data="xrays"
                    :loading="areDataLoading"
                    :edit="edit"
                    :hideDeleteButton="true"
                    :columns="columns"
                ></simple-table>
            </div>
        </div>

        <xray-modal id="XrayModal" :xray="model"></xray-modal>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Avatar from '@/components/Avatar.vue'
import CardLoading from '@/components/CardLoading.vue';
import DateFilter from '@/components/DateFilter.vue';
import {modalMixins} from '@/mixins/modal.js'
import {mapActions, mapGetters, mapState} from 'vuex';
import XrayModal from './XrayModal';
import SimpleTable from '@/components/SimpleTable'
import xrayType from '@/filters/xrays.js';

export default {
    props: ['id'],
    mixins: [modalMixins],
    components: {
        Avatar,
        XrayModal,
        DateFilter,
        CardLoading,
        SimpleTable,
    },
    data() {
        return {
            staffQuery: [],
            query: null,
            dates: {},
            filter: 'upcoming',
            xrayDefaults: {
                customerId: this.$route.params.id,
                quantity: 1,
                type: 'intraoral'
            },
            fileData: {
                customerId: this.$route.params.id,
            },
            params: {
                query: {
                    $limit: 100,
                    customerId: this.$route.params.id,
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            columns: [
                {
                    label: 'Tooth #',
                    name: 'tooth',
                    sortable: true,
                    field(row) {
                        if (!row.tooth) return;
                        return `<h2>${row.tooth}</h2>`;
                    }
                },
                {
                    label: 'Date',
                    name: 'xrayAt',
                    sortable: true,
                    duration: true,
                    date_format: 'MMMM D, YYYY'

                },

                {
                    label: 'Type',
                    name: 'type',
                    field: (row) => {
                        return this.$t(xrayType(row.type).label);
                    },
                    sortable: true,
                },
                {
                    label: 'Quantity',
                    name: 'quantity',
                    sortable: true,
                },
                {
                    label: 'Dose',
                    name: 'dose',
                    sortable: true,
                },
            ],
        }
    },
    computed: {
        ...mapState('xrays', {areDataLoading: 'isFindPending'}),
        ...mapGetters('xrays', {findDataInStore: 'find'}),
        ...mapState('my-team', {isTeamLoading: 'isFindPending'}),
        ...mapGetters('my-team', {findTeamInStore: 'find', user: 'get'}),


        services() {
            return this.findServicesInStore({query: {$sort: {priority: 1}}}).data;
        },
        treatments() {
            return this.findTreatmentInStore().data;
        },
        xrays() {
            let items = this.findDataInStore(this.params).data;
            items.map(item => {
                item.user = this.user(item.userId);
            })
            return items;
        },

        staff() {
            return this.findTeamInStore().data;
        },

        customerId() {
            return this.$parent.customer._id;
        }
    },
    created() {

        this.find(this.params);
        // this.fetchTeam();

    },
    watch: {

        dates: debounce(function(newVal) {
            if (newVal.start) {
                this.params.query.xrayAt = {
                    $gte: newVal.start,
                    $lte: newVal.end
                }
            } else {
                delete this.params.query.xrayAt;
            }
            this.fetchData();
        }, 400),

        query: debounce(function(newVal) {
            if (newVal) {
                this.params.query.$or = [
                    {notes: {$regex: newVal, $options: "i"}},
                    {label: {$regex: newVal, $options: "i"}},
                ];
            } else {
                delete this.params.query.$or;
            }

            this.fetchData();
        }, 400),

        /* Find by staf  */
        staffQuery: debounce(function(newVal) {
            if (newVal.length <= 0) {
                delete this.params.query.services;
            } else {
                this.params.query.services = {userId: {$in: newVal}};
            }
            this.fetchData();
        }, 400),
    },
    methods: {
        ...mapActions('xrays', ['find']),
        edit(item) {
            this.openModal({
                id: 'XrayModal',
                model: item
            })
        },

        fetchData() {
            this.find(this.params);
        },
        use(image) {
            this.$root.$emit('bv::hide::modal', this.id);
            this.action(image);
        },
        save() {
            this.errors = null;
            this.hideForm = true;
        },


    },


}
</script>
